module.exports = __webpack_public_path__ + "img/icon_education_bottomnav.415cb9b.svg";